<template>

	<b-container class="pt-1">
		<div class="pull-left">
			<b-button variant="primary" @click="saveInventory('backButton')">
				<i class="fa fa-chevron-left"></i>
				{{ $t('back') }}
			</b-button>
		</div>
		<div class="pull-right">
		</div>
		<b-modal id="bv-modal-example" hide-footer v-model="openReturn">

			<!--<template slot="modal-title">

			</template>-->
			<div slot="modal-header">
				<div slot="modal-title">
					<span v-if="activeModalVozvratOrSpisat === 'vozvrat'">Возврать</span>
					<span v-else-if="activeModalVozvratOrSpisat === 'spisat'">Списать</span>
					<span v-else>Регулировать</span>
					<span v-if="pleaseInput" style="color: red;" class="ml-3">Заполните форму</span>
				</div>
			</div>
			<div v-if="activeModalVozvratOrSpisat==='vozvrat'">
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('incomes.create.warehouse')"
						size="sm"
					>
						<b-form-select
							value-field="id"
							text-field="name"
							:options="dropdowns.departments"
							v-model="item.departmentId"
							size="sm">
							<template slot="first">
								<option :value="null">-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('incomes.create.count')"
						size="sm">
						<b-form-input v-model="count" size="sm" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<div class="col-4" style="float: right">
					<b-button size="sm" class="btn btn-success" block @click="saveVozvrat">{{$t('actions.save')}}
					</b-button>
				</div>
			</div>
			<div v-if="activeModalVozvratOrSpisat==='spisat'">
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('incomes.create.count')"
						size="sm">
						<b-form-input v-model="count" size="sm" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('employees.create.comment')"
						size="sm">
						<b-form-input v-model="comment" size="sm" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>

				<div class="col-4" style="float: right">
					<b-button size="sm" class="btn btn-success" block @click="saveSpisat">{{$t('actions.save')}}
					</b-button>
				</div>
			</div>
			<div v-if="activeModalVozvratOrSpisat==='boyniga'">
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('incomes.create.count')"
						size="sm">
						<b-form-input v-model="count" size="sm" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						:label="$t('client.create.first-name')"
						size="sm">
						<b-form-input v-model="name" size="sm" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>

				<div class="col-4" style="float: right">
					<b-button size="sm" class="btn btn-success" block @click="saveBoynigaQoyish">
						{{$t('actions.save')}}
					</b-button>
				</div>
			</div>
		</b-modal>
		<div class="clearfix"></div>
		<div v-if="this.loading" class="spinner-wrapper">
			<b-spinner variant="primary"></b-spinner>
		</div>
		<b-card v-if="!this.loading" class="mt-2">
			<div class="text-center font-weight-bold  mb-3">
				<h1 class="text-uppercase" v-if="fetchDetail">{{ fetchDetail.inventory.inventoryNumber }}</h1>
				<h1 class="text-uppercase" v-else-if="currentInventory">{{ currentInventory.inventoryNumber }}</h1>
				<h1 class="text-uppercase" v-else-if="inventoryById">{{ inventoryById.inventoryNumber }}</h1>
			</div>
			<!--<div class="row">-->

			<!--<div class="col-3">-->
			<!--<b-form-group class="pull-right">-->
			<!--<b-form-radio-group-->
			<!--id="btn-radios-2"-->
			<!--v-model="countType"-->
			<!--:options="types"-->
			<!--buttons-->
			<!--button-variant="outline-primary"-->
			<!--size="sm"-->
			<!--name="radio-btn-outline"-->
			<!--&gt;</b-form-radio-group>-->
			<!--</b-form-group>-->
			<!--<div class="clearfix"></div>-->
			<!--<div class="col-3">-->
			<!--<b-button class="btn btn-success" size="sm" @click="saveInventory">Saqlash-->
			<!--</b-button>-->
			<!--</div>-->
			<!--</div>-->
			<!--</div>-->

			<!--<div class="text-right mb-2">-->
			<!--</div>-->
			<div class="row">
				<div class="col-5">
					<div class="text-left mb-2">
				<span class="font-weight-bold">{{ $t('inventory.description')
					}}</span>: <span v-if="fetchDetail">{{ fetchDetail.inventory.description }}</span>
						<span v-else-if="currentInventory">{{ currentInventory.description }}</span>

					</div>
				</div>

				<div v-if="editable" class="col-7">
					<div class="row d-flex justify-content-end">
						<div class="col-2" v-if="!isParentDoc">
							<b-form-group class="pull-right">
								<b-form-radio-group
									id="btn-radios-2"
									v-model="countType"
									:options="types"
									buttons
									button-variant="outline-primary"
									size="sm"
									name="radio-btn-outline"
								></b-form-radio-group>
							</b-form-group>
							<div class="clearfix"></div>

						</div>
						<div class="col-10">
							<b-button
								size="sm"
								variant="outline-primary"
								@click="excelExport('whDocTable')"
								class="mr-2"
							>
								{{ $t('excel-export.download-excel') }}
							</b-button>
							<b-button class="mr-2" variant="outline-info" size="sm" @click="showSideBar"
									  v-if="isAdmin && isParentDoc">
								{{$t('sidebar.warehouse-management.income')}}
							</b-button>
							<b-button class="mr-2" variant="outline-info" size="sm" @click="showSideBar('write-off')"
									  v-if="isAdmin && isParentDoc">
								{{$t('pending.off')}}
							</b-button>
							<b-button class="mr-2" variant="outline-danger" size="sm" @click="showDeleteModal"
									  v-if="isAdmin && isParentDoc">
								{{$t('actions.delete')}}
							</b-button>
							<b-button class="mr-2" variant="outline-success" size="sm" @click="showFinishModal"
							>
								{{ $t('save-finish')}}
							</b-button>
							<b-button class="btn btn-warning" size="sm" @click="saveInventory('saveButton')"
									  v-if="!isParentDoc">

								{{$t('actions.save')}}
							</b-button>
						</div>
					</div>
				</div>
				<div  v-else class="col-7">
					<div class="row d-flex justify-content-end">
						<div class="col-10">
							<b-button
								size="sm"
								variant="outline-primary"
								@click="excelExport('whDocTable')"
								class="mr-2"
							>
								{{ $t('excel-export.download-excel') }}
							</b-button>
						</div>
					</div>
				</div>

			</div>
			<br>
			<div>
				<h4 class="text-center">
					<p v-if="lastAddedItem">
						<span class="text-success">{{$t('last-product')}}: </span> <b> {{ lastAddedItem}}</b>
					</p>
					<p v-if="lastNotAddedItem">
						<span class="text-danger">{{ $t('warehouse.document.itemNotFound') }} </span> : <b> {{
						lastNotAddedItem}}</b>
					</p>
				</h4>
			</div>
			<b-table v-if="!this.loading" class="generalTableClass" id="whDocTable"
					 hover="hover"
					 striped="striped"
					 bordered="bordered"
					 small="small"
					 fixed="fixed"
					 :items="accepted"
					 responsive="sm"
					 :fields="columns"
			>
				<template slot="id" slot-scope="data">
					<strong>{{ data.index + 1}}</strong>
				</template>
				<template slot="count" slot-scope="data">
					<div class="w-75p">
						<b-input-group size="sm">
							<b-input type="number"
									 @keydown="keydown(data.index)"
									 v-model="data.item.count"
									 :disabled="isBarcode"
									 @input="countEnter($event,data.index)"
									 @focus="$event.target.select()"
									 min="0"
									 size="sm"></b-input>
							<b-input-group-addon>

							</b-input-group-addon>
						</b-input-group>
						<span style="display: none">{{data.item.count}}</span>
					</div>
				</template>
				<template slot="difference" slot-scope="data">
					{{data.item.difference}}
					<span class="w-24p text-center">
						<span class="text-danger" v-if="data.item.difference!=0"><i
							class="fa fa-question-circle"></i></span>

						<span class="text-success" v-else>
						<i class="fa fa-check"></i>
						</span>
						</span>
				</template>
				<template slot="actions" slot-scope="data">
					<b-link size="sm"
							v-b-tooltip.hover title="Возврать">
						<i class="fa fa-refresh"
						   @click="returnItem(data.index)"></i>
					</b-link>
					<b-link size="sm"
							v-b-tooltip.hover title="Списать">
						<i class="nav-icon fa fa-minus-square-o"
						   @click="oepnSpisatModal(data.index)"></i>
					</b-link>

					<b-link size="sm" v-b-tooltip.hover title="Регулировать">
						<i class="nav-icon fa fa-gear" @click="boynigaQoyish(data.index)"></i>
					</b-link>
				</template>
			</b-table>

			<!-- FINISH CONFIRM MODAL -->
			<b-modal
				v-model="finishModal"
				@ok="finishInventoryLocal"
				ok-title="Да"
				cancel-title="Отмена"
			>
				<h4>Вы уверены, что хотите завершить?</h4>
			</b-modal>

			<!-- DELETE CONFIRM MODAL -->
			<b-modal
				v-model="deleteModal"
				@ok="deleteInventoryLocal"
				ok-title="Да"
				cancel-title="Отмена"
			>
				<h4>Вы уверены, что хотите отменить и удалить?</h4>
			</b-modal>

			<vs-sidebar :click-not-close="true"
						position-right
						parent="body"
						default-index="1"
						color="primary"
						class="create-modal-wh"
						spacer
						v-model="sidebar.open">
				<b-container>
					<create-form
						:formItem="formItem"
						:respPersonList="employees.items"
						@cancel="hideVsSideBar"
					></create-form>
				</b-container>
			</vs-sidebar>
		</b-card>
	</b-container>
</template>
<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
<script>
	import {mapGetters, mapActions, mapState} from 'vuex';
	import UsersService from "../../../services/users.sevice";
	import BCol from "bootstrapVueOld/src/components/layout/col";
	import Vue from 'vue';
	import CreateForm from "./block/CreateForm";
	import WhDocument from "../../../services/wh-document.service";
	import InventoryService from "../../../services/Inventory.service";

	export default {
		components: {BCol, CreateForm},
		name: "Print",
		data() {
			return {
				sectionName: 'KIRIM',
				editable: false,
				finishModal: false,
				deleteModal: false,
				pleaseInput: false,
				count: 0,
				lastAddedItem: null,
				lastNotAddedItem: null,
				comment: '',
				name: '',
				currentItem: '',
				currentIndex: '',
				activeModalVozvratOrSpisat: '',
				dropdowns: {
					departments: [],
					category: [],
					employee: null
				},
				item: {
					departmentId: null,
					inventoryNumber: null,
					description: null,
					categoryId: null,
					responsibleId: null
				},
				columns: [],
				sidebar: {
					open: false,
					close: false,

				},

				formItem: {
					fromDepartmentId: false,
					toDepartmentId: null,
					reason: '',
					comment: '',
					whItems: [],
					action: 'KIRIM',
					responsible1: false,
					title: '',
					inventoryId: null,
				},
				countType: 'Штрихкод',
				accepted: [],
				tempArray: [],
				types: ['Штрихкод', 'Ручной'],
				openReturn: false,
				isParentDoc: true,
				docAllChildsFinished: false,
			}
		},
		computed: {
			...mapGetters('inventory', [
				'fetchDetail', 'getByInventoryRes'
			]),
			...mapState('warehouse', [
				'sectors'
			]),
			...mapState('inventory', [
				'responseSuccess', 'getByInventoryRes',
				'currentInventory', 'inventoryById',
				'returnError', 'saveInventoryError',
				'saveInventoryErrorMessage', 'finishInventoryError', 'finishInventoryErrorMessage',
				'deleteInventoryError', 'deleteInventoryErrorMessage', 'loading'
			]),
			...mapState(['isCashier', 'isAdmin', 'isManager']),
			...mapState('goods', [
				'itemWithBarcode', 'barcodeError'
			]),
			...mapState('employees', [
				'employees',
			]),

			isBarcode() {
				return this.countType === 'Штрихкод';
			},
		},
		mounted() {
		},
		beforeDestroy() {
			this.$store.commit('inventory/setCurrentInventory', null)
		},
		async created() {
			this.setDefColumns();
			await this.reload();
			if (!this.isParentDoc)
				this.$barcodeScanner.init(this.onBarcodeScanned);

		},
		methods: {
			...mapActions('inventory', [
				'saveVozvratForInventory', 'finishInventory',
				'saveInventoryList', 'saveSpisatStore',
				'getInventoryById', 'getInventoryItemsById',
				'saveSpisatForInventory', 'saveBoynigaQoyishForInventory',
				'inventoryDelete'
			]),
			...mapActions('goods', [
				'fetchItemWithBarcode',
			]),
			...mapActions('employees', [
				'getDepartmentByEmployeeList',
			]),
			excelExport(table) {
				let fileName = '';
					if(this.currentInventory){
						fileName = this.currentInventory.inventoryNumber;
					}else if (this.fetchDetail){
						fileName = this.fetchDetail.inventory.inventoryNumber;
					}else{
						fileName = this.inventoryById.inventoryNumber;
					}




				var uri = 'data:application/vnd.ms-excel;base64,'
					,
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					}
					, downloadURI = function (uri, name) {
						var link = document.createElement("a");
						link.download = name;
						link.href = uri;
						link.click();
					}

				if (!table.nodeType) table = document.getElementById(table)
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
				var resuri = uri + base64(format(template, ctx))
				downloadURI(resuri, fileName);
			},
			async reload() {
				if (this.currentInventory) {
					await this.$store.commit('inventory/setDetail', null);
					this.editable = !this.currentInventory.finishDate;
					this.isParentDoc = this.currentInventory.isParent;
					await this.getInventoryItemsById(this.currentInventory.id);
					this.tempArray = await this.getByInventoryRes;
					this.accepted = JSON.stringify(this.tempArray.slice());
					this.accepted = JSON.parse(this.accepted);
					this.fetchPermissions();
					this.$store.commit('inventory/setLoading', false);

				} else if (this.fetchDetail) {
					this.editable = !this.fetchDetail.finishDate;
					this.isParentDoc = this.fetchDetail.isParent;
					this.tempArray = this.fetchDetail.itemBalanceDtoList;
					this.accepted = JSON.stringify(this.tempArray.slice());
					this.accepted = JSON.parse(this.accepted).map(this.resetCount)
					this.accepted.forEach(el => {
						el.difference = el.count - el.inventory
					})
					this.fetchPermissions();

					await this.saveInventory('fromCreated');
				} else {
					let inventoryId = this.$route.params.id;
					await this.getInventoryById(inventoryId);
					this.editable = !this.inventoryById.finishDate;
					this.isParentDoc = this.inventoryById.isParent;
					await this.getInventoryItemsById(inventoryId);
					this.tempArray = await this.getByInventoryRes;
					this.accepted = JSON.stringify(this.tempArray.slice());
					this.accepted = JSON.parse(this.accepted);
					this.fetchPermissions();
					this.$store.commit('inventory/setLoading', false);
				}
			},

			async showSideBar(mode = 'income') {

				await InventoryService.checkAllChildFinish(this.currentInventory.id ? this.currentInventory.id : this.fetchDetail.inventory.id).then(response => {
					this.docAllChildsFinished = response.data;
				});

				if (!this.docAllChildsFinished) {

					this.$vs.notify({
						time: 3000,
						title: 'Документ еще не закончен, запрещены какие либо действие кроме удалить!',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					return false;
				}

				if (this.currentInventory) {
					this.formItem.toDepartmentId = this.currentInventory.departmentId
					this.formItem.inventoryId = this.currentInventory.id
				} else {
					this.formItem.toDepartmentId = this.fetchDetail.inventory.departmentId;
					this.formItem.inventoryId = this.fetchDetail.inventory.id;
				}

				switch (mode) {
					case 'transfer':
						this.formItem.title = this.$t('kochirish.create');
						this.formItem.toDepartmentId = null;
						this.formItem.action = 'KOCHIRISH';
						break;
					case 'write-off':

						// Условия для списание
						await this.getDepartmentByEmployeeList({
							id: this.formItem.toDepartmentId,
							pageLimit: {
								page: 1,
								limit: 999999
							}
						});
						this.formItem.responsible1 = null;
						this.formItem.action = 'SPISAT';
						this.formItem.whItems = this.accepted.filter(function (number) {
							return number.difference < 0;
						});
						this.formItem.title = this.$t('pending.off');
						break;
					default:
						// Условия для приход
						this.formItem.title = this.$t('kirim.create');
						this.formItem.whItems = this.accepted.filter(function (number) {
							return number.difference > 0;
						});
				}

				// await InventoryService.getListItemWithPrice(this.formItem.toDepartmentId,this.formItem.whItems).then(response => {
				// 	this.formItem.whItems = response.data;
				// });

				this.sidebar.open = true;
			},
			async hideVsSideBar() {
				this.sidebar.open = false;
				this.formItem = {
					fromDepartmentId: false,
					toDepartmentId: null,
					reason: '',
					comment: '',
					whItems: [],
					action: 'KIRIM',
					responsible1: false,
					title: '',
					inventoryId: null,
				};
				//await this.reload();

			},
			async loadSector(id) {
				await WhDocument.getSectorByDepartmentId(id).then(response => {
					this.dropdowns.sector = response;
					this.$store.commit('warehouse/setSector', this.dropdowns.sector);
				})
			},
			async setDefColumns() {
				if (this.isAdmin || this.isManager) {
					this.columns = [
						{
							key: 'id',
							label: '№',
							visible: true,
							changebale: false
						},
						{
							key: 'artikul',
							label: this.$t('goods.artikul'),
							visible: true,
							changebale: false
						},
						{
							key: 'itemName',
							label: this.$t('sidebar.warehouse-management.products'),
							visible: true,
							changebale: false,

						},
						{
							key: 'sub2CategoryName',
							label: this.$t('goods.category'),
							visible: true,
							changebale: false
						},
						{
							key: 'color',
							label: this.$t('goods.color'),
							visible: true,
							changebale: false
						},
						{
							key: 'inventory',
							label: this.$t('sidebar.warehouse-management.inventory'),
							visible: true,
							changebale: false,
							class: 'textAlignCenter'
						},
						{
							key: 'count',
							label: this.$t('incomes.create.count'),
							visible: true,
							changebale: false,
							class: 'w-300 textAlignCenter',
							width: '18%',
						},
						{
							key: 'difference',
							label: 'Разница',
							visible: true,
							changebale: false,
							class: 'textAlignCenter'
						},
						// {
						// 	key: 'actions',
						// 	label: this.$t('actions.title'),
						// 	visible: true,
						// 	changebale: false,
						// 	class: 'textAlignCenter table_actions'
						// },
					];
				}

				if (this.isCashier) {
					this.columns = [
						{
							key: 'id',
							label: '№',
							visible: true,
							changebale: false
						},
						{
							key: 'artikul',
							label: this.$t('goods.artikul'),
							visible: true,
							changebale: false
						},
						{
							key: 'itemName',
							label: this.$t('sidebar.warehouse-management.products'),
							visible: true,
							changebale: false,

						},
						{
							key: 'sub2CategoryName',
							label: this.$t('goods.category'),
							visible: true,
							changebale: false
						},
						{
							key: 'color',
							label: this.$t('goods.color'),
							visible: true,
							changebale: false
						},
						{
							key: 'count',
							label: this.$t('incomes.create.count'),
							visible: true,
							changebale: false,
							class: 'w-300 textAlignCenter',
							width: '18%',
						},


					]
				}
			},
			async onBarcodeScanned(barcode) {

				await this.fetchItemWithBarcode(barcode);
				if (this.barcodeError) {

					this.changeLastNotAddedItem(barcode)
				} else {
					const income = this.findIncome(this.itemWithBarcode);
					let index = this.accepted.indexOf(income);
					if (this.accepted.length > 0 && income) {
						this.accepted[this.accepted.indexOf(income)].count++;
						this.setRowVariation(index, true);
						if (this.accepted[this.accepted.indexOf(income)].inventory < 0) {
							this.accepted[this.accepted.indexOf(income)].difference = this.accepted[this.accepted.indexOf(income)].count - (-1) * this.accepted[this.accepted.indexOf(income)].inventory;
							this.accepted[this.accepted.indexOf(income)].changed = true;
							this.count = this.accepted[this.accepted.indexOf(income)].difference;
						} else {
							this.accepted[this.accepted.indexOf(income)].difference = this.accepted[this.accepted.indexOf(income)].count - this.accepted[this.accepted.indexOf(income)].inventory;
							this.accepted[this.accepted.indexOf(income)].changed = true;
							this.count = this.accepted[this.accepted.indexOf(income)].difference;
						}

					}
				}


			},
			showDeleteModal() {
				this.deleteModal = true;
			},
			async deleteInventoryLocal() {
				this.deleteModal = false;
				await this.inventoryDelete(this.$route.params.id);
				if (!this.deleteInventoryError) {
					this.$vs.notify({
						title: 'Инвентаризация успешно удалено',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
					this.$router.push('/warehouse-management/inventory');
				} else {
					this.$vs.notify({
						title: this.deleteInventoryErrorMessage,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			async showFinishModal() {
				await InventoryService.checkAllChildFinish(this.currentInventory.id ? this.currentInventory.id : this.fetchDetail.inventory.id).then(response => {
					this.docAllChildsFinished = response.data;
				});

				if (!this.docAllChildsFinished) {

					this.$vs.notify({
						time: 3000,
						title: 'Документ еще не закончен, запрещены какие либо действие кроме удалить!',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					return false;
				}
				this.finishModal = true;
			},
			async finishInventoryLocal() {
				this.finishModal = false;
				await this.saveInventory();
				if (!this.saveInventoryError) {
					await this.finishInventory(this.$route.params.id);
				} else {
					this.$vs.notify({
						title: this.saveInventoryErrorMessage,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
				if (!this.finishInventoryError) {
					this.$router.push('/warehouse-management/inventory');
				} else {
					this.$vs.notify({
						title: this.finishInventoryErrorMessage,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			async countEnter(value, index) {
				this.accepted[index].difference = value - this.accepted[index].inventory;
				this.setRowVariation(index);

			},
			async setRowVariation(index, change = false) {
				Vue.set(this.accepted[index], '_rowVariant', 'primary');
				this.changeLastAddedItem(this.accepted[index]);
				if (change)
					this.swapItems(index);
				//this.swapItems(index);

				let vm = this;
				await setTimeout(function () {
					delete vm.accepted[index]['_rowVariant'];
				}, 500);
			},
			swapItems(index) {
				var tmp = this.accepted[0];
				this.accepted[0] = this.accepted[index];
				this.accepted[index] = tmp;
			},
			changeLastAddedItem(item) {
				this.lastNotAddedItem = false;
				this.lastAddedItem = item.artikul + " " + item.itemName + " " + item.color;
				this.$vs.notify({
					time: 1000,
					title: 'Выполнена успешно!',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			},
			changeLastNotAddedItem(barcode) {
				this.lastAddedItem = false;
				this.lastNotAddedItem = barcode;

			},
			checkIsKam(index) {
				if (this.accepted[index].count < parseInt(this.accepted[index].inventory)) {
					return true;
				} else {
					return false;
				}
			},
			keydown(index) {
				this.accepted[index].changed = true
			},
			checkIsKop(index) {
				if (this.accepted[index].count > parseInt(this.accepted[index].inventory)) {

					return true;
				} else {
					return false;
				}

			},
			checkIsTeng(index) {
				if (this.accepted[index].count = parseInt(this.accepted[index].inventory)) {

					return true
				} else {
					return false;
				}
			},
			boynigaQoyish(index) {
				if (this.accepted[index].difference < 0) {
					this.currentItem = this.accepted[index];
					this.currentIndex = index;
					this.count = (-1) * this.accepted[index].difference
					this.openReturn = true;
					this.pleaseInput = false;
					this.activeModalVozvratOrSpisat = 'boyniga';
				}
			},
			async saveBoynigaQoyish() {
				if (this.name.trim() !== '') {
					let data = {};
					if (this.fetchDetail) {
						data.count = this.count;
						data.itemId = this.currentItem.itemId;
						data.inventoryId = this.fetchDetail.inventory.id;
						data.fromDepartmentId = this.fetchDetail.inventory.departmentId;
						data.fio = this.name;
					}
					if (this.currentInventory) {
						data.count = this.count;
						data.itemId = this.currentItem.itemId;
						data.inventoryId = this.currentInventory.id;
						data.fromDepartmentId = this.currentInventory.departmentId;
						data.fio = this.name;
					}
					await this.saveBoynigaQoyishForInventory(data);
					if (!this.returnError) {
						this.accepted[this.currentIndex].inventory = this.accepted[this.currentIndex].inventory - parseInt(this.count);
						this.accepted[this.currentIndex].difference = this.accepted[this.currentIndex].count - this.accepted[this.currentIndex].inventory;
					}
					this.openReturn = false;
					this.pleaseInput = false;
				} else {
					this.pleaseInput = true;
				}
			},
			async saveVozvrat() {
				if (this.item.departmentId) {
					let data = {};
					if (this.fetchDetail) {
						data.fromDepartmentId = this.fetchDetail.inventory.departmentId;
						data.toDepartmentId = this.item.departmentId;
						data.count = this.count;
						data.inventoryNumber = this.fetchDetail.inventory.inventoryNumber;
						data.inventoryId = this.fetchDetail.inventory.id;
						data.item = this.currentItem;
					}
					if (this.currentInventory) {
						data.fromDepartmentId = this.currentInventory.departmentId;
						data.toDepartmentId = this.item.departmentId;
						data.count = this.count;
						data.inventoryNumber = this.currentInventory.inventoryNumber;
						data.inventoryId = this.currentInventory.id;
						data.item = this.currentItem;
					}

					await this.saveVozvratForInventory(data);
					if (!this.returnError) {
						this.accepted[this.currentIndex].count = this.accepted[this.currentIndex].count - this.count;
						this.accepted[this.currentIndex].difference = this.accepted[this.currentIndex].count - this.accepted[this.currentIndex].inventory;
					}

					this.openReturn = false;
					this.pleaseInput = false;
				} else {
					this.pleaseInput = true;
				}

			},
			async saveSpisat() {
				if (this.comment.trim() !== '') {
					const data = {};
					if (this.fetchDetail) {
						data.count = this.count;
						data.comment = this.comment;
						data.item = this.currentItem;
						data.inventoryNumber = this.fetchDetail.inventory.inventoryNumber;
						data.inventoryId = this.fetchDetail.inventory.id;
						data.fromDepartmentId = this.fetchDetail.inventory.departmentId;
					}
					if (this.currentInventory) {
						data.count = this.count;
						data.comment = this.comment;
						data.item = this.currentItem;
						data.inventoryNumber = this.currentInventory.inventoryNumber;
						data.inventoryId = this.currentInventory.id;
						data.fromDepartmentId = this.currentInventory.departmentId;
					}
					await this.saveSpisatStore(data);
					if (!this.returnError) {
						this.accepted[this.currentIndex].inventory = this.accepted[this.currentIndex].inventory - parseInt(this.count);
						this.accepted[this.currentIndex].difference = this.accepted[this.currentIndex].count - this.accepted[this.currentIndex].inventory;
					}
					this.openReturn = false;
					this.pleaseInput = false;
				} else {
					this.pleaseInput = true;
				}
				this.comment = '';
			},
			async saveInventory(fromButton) {
				const data = {};
				if (this.fetchDetail) {
					data.inventoryId = this.fetchDetail.inventory.id;
					data.inventoryNumber = this.fetchDetail.inventory.inventoryNumber;
					data.inventoryList = this.accepted;
				} else if (this.currentInventory) {
					data.inventoryId = this.currentInventory.id;
					data.inventoryNumber = this.currentInventory.inventoryNumber;
					data.inventoryList = this.accepted;
				} else {
					data.inventoryId = this.$route.params.id;
					data.inventoryNumber = this.getByInventoryRes.inventoryNumber;
					data.inventoryList = this.accepted;
				}
				if (fromButton == 'fromCreated') {
					if (data.inventoryList.length > 0) {
						data.inventoryList.forEach(el => {
							el.inventoryId = data.inventoryId;
						});
					}
					if (this.accepted.length > 0) {
						this.accepted.forEach(el => {
							el.inventoryId = data.inventoryId;
						});
					}
				}
				if (this.editable) {
					if (!this.isParentDoc) {
						await this.saveInventoryList(data);
					}

					if (fromButton == 'fromCreated') {
						if (!this.saveInventoryError && this.responseSuccess) {
							let tempArray = this.responseSuccess;
							this.accepted = JSON.stringify(tempArray.slice());
							this.accepted = JSON.parse(this.accepted);
						}
					}
				}
				if (fromButton == 'backButton') {
					this.$router.push('/warehouse-management/inventory');
				} else if (fromButton == 'saveButton') {
					if (!this.saveInventoryError) {
						this.$vs.notify({
							title: 'Инвентаризация успешно сохранен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.$router.push('/warehouse-management/inventory');
					} else {
						this.$vs.notify({
							title: this.saveInventoryErrorMessage,
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
			},

			fetchPermissions() {
				if (this.$can('get', 'permitted departments')) {
					UsersService.getPermittedDepartments().then(response => {
						this.dropdowns.departments = response.data.transferPermittedDepartments;
					})
				}
			},
			returnItem(index) {
				if (this.accepted[index].difference > 0) {
					this.openReturn = true;
					this.pleaseInput = false;
					this.activeModalVozvratOrSpisat = 'vozvrat';
					this.currentItem = this.accepted[index];
					this.currentIndex = index;
					this.count = this.accepted[index].difference;
				}
			},
			oepnSpisatModal(index) {
				if (!this.accepted[index].difference || this.accepted[index].difference < 0) {
					this.currentItem = this.accepted[index];
					this.count = (-1) * this.accepted[index].difference;
					this.currentIndex = index;
					this.openReturn = true;
					this.pleaseInput = false;
					this.activeModalVozvratOrSpisat = 'spisat';
				}
			},

			fullName({firstName, lastName, middleName}) {
				return `${firstName} ${lastName} ${middleName}`;
			},
			findIncome(response) {
				return this.accepted.find((item) => {
					if (item.itemId === response.id) {
						return item;
					}
				})
			},
			resetCount(item) {
				item.changed = false;
				item.count = 0;
				return item;
			},

			print() {
				window.print();
			},
		},
//		watch: {
//			accepted: {
//				deep: true,
//				handler(newValue) {
//					this.hasShortage = false;
//					this.accepted.map((item, i) => {
//						if (parseInt(item.count) !== this.accepted[i].count && item.changed) {
//							this.hasShortage = true;
//						}
//					})
//				}
//			}
//		}
	}
</script>

<style scoped>
	.textAlignCenter {
		text-align: center;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 12px;
		z-index: 5;
	}

	.table-wrapper {
		position: relative;
		padding: 5px;
	}
</style>
